export enum WithdrawStatus {
  Pending = 0,
  Approved = 1,
  Rejected = 2,
  InProgress = 3,
  Risky = 4,
  IncompletePayout = 5,
}
